// Flags de publicación de las spokes de marketing del sitio público.
//
// Antes era un único booleano para /pricing, /chain y /features, así que las
// tres tenían que estar listas a la vez para poder enseñar cualquiera. Al
// mover los packs de la home a /pricing esa página pasó a ser obligatoria
// —si no, el sitio se queda sin precios en ningún sitio— mientras /chain
// sigue sin terminar. De ahí el mapa por página.
//
// Al poner una en `true` hay que sincronizar TRES sitios más o la página
// existe pero no la encuentra nadie:
//   · `PUBLIC_PAGES` en vite.config.ts   → entra en el prerender (×3 idiomas)
//   · `scripts/gen-sitemap.cjs`          → entra en el sitemap
//   · el rewrite de `vercel.json`        → se sirve en producción
export const MARKETING_PAGES = {
  pricing: true,
  features: true,
  /** Sales-led y todavía sin copy definitivo. */
  chain: false,
} as const;

export type MarketingPage = keyof typeof MARKETING_PAGES;

export function isMarketingPageEnabled(page: MarketingPage): boolean {
  return MARKETING_PAGES[page];
}
